import React, { Component, Fragment, createRef } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import myma_logo from './../../assets/myma_logo.png';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import { postAPI_ForgotPassword, API_PAGE_CONTENT } from '../../constants/APIs';
import { NotificationManager } from '../../components/common/react-notifications';
import ReCAPTCHA from 'react-google-recaptcha';
import parse from 'html-react-parser';
export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
    this.state = {
      email: '',
      loading: false,
      process: false,
      type: 'bmb',
      vaildation: { email: '', recaptacha: '', msg: '' },
    };
  }
  handleChangeEmail = (email) => {
    this.setState({
      email: email.target.value,
    });
  };

  onUserForgot() {
    const token = this.myRef.current.getValue();
    let isValid = true;
    let errors = {};
    if (this.state.email === '') {
      isValid = false;
      errors.email = 'Please enter email';
    }
    if (this.state.email !== '') {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) {
        isValid = false;
        errors.email = 'Invalid email address';
      }
    }
    if (this.state.email !== '' && errors.email === undefined && token === '') {
      isValid = false;
      errors.recaptacha = 'Please Verify the Recaptcha';
    }
    this.setState({ vaildation: errors });
    if (isValid) {
      this.setState({ process: true, loading: true });
      this.myRef.current.reset();
      let data = {
        email: this.state.email,
        source: 'bmb',
        type: this.extractType(),
      };
      const recaptacha = {
        token: token,
        inputData: data,
      };
      AxiosPublicAPI({
        method: 'post',
        url: `${postAPI_ForgotPassword}`,
        data: recaptacha,
      }).then(
        (res) => {
          if (res.data !== 'not verified') {
            this.setState({ loading: false });
          } else {
            this.setState({ process: false, loading: false });
          }
          // NotificationManager.success(
          //   'Please check your email',
          //   'Forgot Password Success',
          //   3000,
          //   null,
          //   null,
          //   'success'
          // );
        },
        (error) => {
          var errormsg = '';
          if (
            error.response.data.message ===
            'ThrottlerException: Too Many Requests'
          ) {
            errormsg =
              'You have attempted many times. Please try after sometime.';
          }
          this.setState({ vaildation: { msg: errormsg } });
          console.log('eee.data', error);
        }
      );
    }
  }
  onChange(value) {
    console.log('Captcha value:', value);
  }
  extractType() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      return 'synxis';
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      return 'bmb';
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      return 'bmb';
    } else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      return 'myma';
    else return this.state.type;
  }
  extractCaptcha() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      return (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          ref={this.myRef}
          // onChange={this.onChange()}
        />
      );
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      return (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          ref={this.myRef}
          // onChange={this.onChange()}
        />
      );
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      return (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          ref={this.myRef}
          // onChange={this.onChange()}
        />
      );
    } else if (window.location.hostname.toLowerCase().includes('myma.ai')) {
      return (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          ref={this.myRef}
          // onChange={this.onChange()}
        />
      );
    } else {
      return (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          ref={this.myRef}
          // onChange={this.onChange()}
        />
      );
    }
  }
  componentDidMount() {
    AxiosPublicAPI({
      method: 'get',
      url: `${API_PAGE_CONTENT}?provider=${this.extractProvider()}&page=forgot-password`,
    }).then(
      (res) => {
        if (
          res.data.contentArea1 !== undefined &&
          res.data.contentArea1 !== null &&
          res.data.contentArea1 !== ''
        )
          this.setState({
            contentArea1: res.data.contentArea1,
          });

        if (
          res.data.contentArea2 !== undefined &&
          res.data.contentArea2 !== null &&
          res.data.contentArea2 !== ''
        )
          this.setState({
            contentArea2: res.data.contentArea2,
          });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  extractProvider() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      return 5;
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      return 1;
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      return 1;
    } else if (window.location.hostname.toLowerCase().includes('myma.ai'))
      return 1;
    else return 1;
  }

  render() {
    console.log(237, this.state?.contentArea1, this.state?.contentArea2);
    return (
      <Row className="h-100" style={{ width: '90%' }}>
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            {this.state?.contentArea1 ? (
              parse(this.state?.contentArea1)
            ) : (
              <div className="position-relative image-side">
                <p className="text-white h2">
                  <b>Empowerment</b> starts here
                </p>
                <p className="white mb-0">
                  Please use your e-mail to reset your password.
                </p>
              </div>
            )}
            <div className="form-side">
              {!this.state.process && (
                <Fragment>
                  <NavLink to={`/`} className="white">
                    {this.state?.contentArea2 ? (
                      parse(this.state?.contentArea2)
                    ) : (
                      <span className="logo-single">
                        {' '}
                        <img src={myma_logo} width="150" height="100" />{' '}
                      </span>
                    )}
                  </NavLink>
                  <CardTitle className="mb-4">
                    <IntlMessages id="user.forgot-password" />
                  </CardTitle>
                  <Form>
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        className="input_sty"
                        type="email"
                        defaultValue={this.state.email}
                        onChange={this.handleChangeEmail}
                      />
                      <IntlMessages id="user.email" />
                      {this.state.vaildation.email && (
                        <div className="invalid-feedback d-block">
                          {this.state.vaildation.email}
                        </div>
                      )}
                    </Label>
                    {this.extractCaptcha()}
                    {this.state.vaildation.recaptacha && (
                      <div className="invalid-feedback d-block">
                        {this.state.vaildation.recaptacha}
                      </div>
                    )}
                    <div className="d-flex justify-content-end align-items-center mt-2">
                      <Button
                        color="primary"
                        className="btn-shadow"
                        size="lg"
                        onClick={() => this.onUserForgot()}
                      >
                        <IntlMessages id="user.reset-password-button" />
                      </Button>
                    </div>
                  </Form>
                </Fragment>
              )}

              {this.state.process &&
                (this.state.loading ? (
                  <Fragment>
                    {this.state.vaildation && this.state.vaildation.msg ? (
                      <div className="text-center">
                        <Spinner color="primary" className="mb-1" />
                        <p>{this.state.vaildation.msg}</p>
                      </div>
                    ) : (
                      <div className="text-center">
                        <Spinner color="primary" className="mb-1" />
                        <p>Your request is in progress</p>
                      </div>
                    )}
                  </Fragment>
                ) : (
                  <div className="text-center">
                    <h2 className="mb-5">
                      Your password reset email has been sent!
                    </h2>
                    <p className="mb-2">
                      We have sent a password reset email to your email address.
                      Please check your inbox/junk to continue.
                    </p>
                  </div>
                ))}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
